// DragDrop.jsx
import { useRef, useState } from "react";

const DragDrop = ({ label, onFileChange, acceptedFormats, maxFiles = 1 }) => {
  const [files, setFiles] = useState([]);
  const [error, setError] = useState("");
  const fileInputRef = useRef(null);

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    handleFiles(Array.from(e.dataTransfer.files));
  };
  const handleFileSelect = (e) => {
    handleFiles(Array.from(e.target.files));
  };

  const handleFiles = (newFiles) => {
    const maxSize = 25 * 1024 * 1024;
    let validFiles = [...files];

    for (let file of newFiles) {
      setError("");
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (file.size > maxSize) {
        setError("Kích thước file vượt quá 25MB.");
        continue;
      }
      if (acceptedFormats && !acceptedFormats.includes(fileExtension)) {
        setError(`Chỉ chấp nhận các định dạng: ${acceptedFormats.join(", ")}`);
        continue;
      }
      if (validFiles.length < maxFiles) {
        validFiles.push(file);
      } else {
        setError(`Chỉ được tải lên tối đa ${maxFiles} tệp.`);
        break;
      }
    }
    setFiles(validFiles);
    onFileChange(validFiles);
  };

  const handleRemoveFile = (index) => {
    const updatedFiles = files.filter((_, i) => i !== index);
    setFiles(updatedFiles);
    onFileChange(updatedFiles);
  };

  const handleClick = () => fileInputRef.current?.click();

  return (
    <>
      {files.length > 0 && (
        <ul className="mt-2 mb-3 text-sm space-y-3">
          {files.map((file, index) => (
            <li
              key={index}
              className="flex items-center justify-between w-full bg-gray-100 p-2 py-4 rounded-md"
            >
              <div className="flex gap-2 items-center">
                <img
                  src="/images/document.png"
                  alt="Icon"
                  className="size-[20px]"
                />
                <label
                  htmlFor={label}
                  className="block text-sm text-gray-500 cursor-pointer"
                >
                  {file ? file.name : label}
                </label>
              </div>
              <button type="button" onClick={() => handleRemoveFile(index)}>
                <img
                  src="/icons/x-close.svg"
                  alt="Remove"
                  className="h-4 w-4"
                />
              </button>
            </li>
          ))}
        </ul>
      )}

      {files.length < maxFiles && (
        <div
          onClick={handleClick}
          onDragOver={handleDragOver}
          onDrop={handleDrop}
          className="border-2 w-full border-dashed border-gray-300 rounded-md p-4 text-center cursor-pointer flex flex-col justify-center items-center space-y-4 hover:border-blue-300"
        >
          <input
            ref={fileInputRef}
            type="file"
            onChange={handleFileSelect}
            className="hidden"
            multiple={maxFiles > 1}
            accept={
              acceptedFormats
                ? acceptedFormats.map((ext) => `.${ext}`).join(",")
                : undefined
            }
            autoComplete="off"
          />
          <img
            src="/images/drag-drop.png"
            alt="File Icon"
            className="w-[66px] h-[66px]"
          />
          <button
            type="button"
            className="font-sf-medium text-sm px-4 py-1 bg-[#0457C2] text-white rounded-lg"
          >
            Tải lên
          </button>
          <label className="block text-sm text-gray-500 cursor-pointer">
            {files.length > 0 ? `${files.length} tệp đã chọn` : label}
          </label>
          {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
        </div>
      )}
    </>
  );
};

export default DragDrop;
